import {mergeGraph, registerGraph} from '@/angular/modules/vrm-graph/config-utils';

registerGraph('stateGraph', stateGraph);

/* @ngInject */
function stateGraph(GraphService, defaultGraph) {
    const GraphColors = GraphService.colors;
    return mergeGraph(defaultGraph(), {
        options: {
            colors: [GraphColors.blue, GraphColors.orange, GraphColors.black],
            plotOptions: {
                series: {
                    minPointLength: 5,
                    turboThreshold: 0,
                    stickyTracking: false
                }
            },
            borderColor: GraphColors.blue,
            chart: {
                marginTop: 0,
                marginLeft: 60,
                marginRight: 60,
                type: 'columnrange',
                zoomType: 'y',
                inverted: true
            },
            tooltip: {
                useHTML: true,
                shared: false,
                pointFormatter: GraphService.statePointFormatter(),
                followPointer: false,
                positioner: GraphService.getTooltipPositionStateGraph
            }
        },
        yAxis: {
            title: {
                text: ''
            },
            type: 'datetime',
            minorTickInterval: 'auto',
            minorGridLineWidth: 0,
            startOnTick: false,
            endOnTick: false,
            minPadding: 0.01,
            maxPadding: 0.01,
            lineColor: '#63625e',
            lineWidth: 1,
            tickWidth: 1,
            tickPixelInterval: 100,
            gridLineWidth: 0
        },
        xAxis: {
            title: {
                text: null
            },
            labels: {
                useHTML: true,
                formatter: GraphService.stateAxisLabelFormatter(),
                style: {
                    color: GraphColors.blue,
                    width: 35
                }
            },
            minorGridLineWidth: 0,
            lineWidth: 0,
            tickWidth: 0,
            gridLineWidth: 1,
            reversed: false
        },
        size: {
            height: null
        },
        series: []
    });
}
